import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLogout } from 'shared/hooks/use-logout';
import { MFA_FAILED_PARAM } from './Login/Login';

export type LogoutLocationState = { isMfaFailed?: boolean };

export const Logout = () => {
  const { state } = useLocation<LogoutLocationState | undefined>();
  const logout = useLogout({
    returnTo: state?.isMfaFailed ? `/login?${MFA_FAILED_PARAM}=1` : undefined,
  });

  useEffect(() => {
    logout();
  }, [logout]);

  return null;
};
